import { Schema } from "effect"

// Re-export everything from shared
export * from "@xsltransform/shared"

// Frontend-specific schemas
export const FiddleInfo = Schema.Struct({
  id: Schema.String,
  revision: Schema.Number,
})
export type FiddleInfo = typeof FiddleInfo.Type

export const DefaultContent = Schema.Struct({
  xml: Schema.String,
  xsl: Schema.String,
})
export type DefaultContent = typeof DefaultContent.Type

export const EditorTab = Schema.Literal("xml", "xsl")
export type EditorTab = typeof EditorTab.Type

export const ResultTab = Schema.Literal("result", "html", "pdf", "console")
export type ResultTab = typeof ResultTab.Type
